import { render, staticRenderFns } from "./OpenInNewWindowButton.vue?vue&type=template&id=26fa688e"
import script from "./OpenInNewWindowButton.vue?vue&type=script&lang=js"
export * from "./OpenInNewWindowButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports